// Maps Supabase's varied credential-error messages to a single
// "doesn't say whether the email exists" response, so a login form
// never reveals which half of a bad email/password pair was wrong.
// Anything unrecognized falls through with the original message so
// rate-limits and network errors stay legible. Shared by the
// scheduler sign-in (SignIn.tsx) and the volunteer sign-in
// (VolunteerLogin.tsx) — same auth backend, same risk.
export function genericizeCredentialError(message: string | undefined): string {
  if (!message) return "Incorrect email or password.";
  const m = message.toLowerCase();
  if (
    m.includes("invalid login") ||
    m.includes("invalid credentials") ||
    m.includes("invalid email or password") ||
    m.includes("invalid_grant")
  ) {
    return "Incorrect email or password.";
  }
  return message;
}
